import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Bot } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const from = location.state?.from?.pathname || '/dashboard';

  React.useEffect(() => {
    if (user) {
      navigate(from);
    }
  }, [user, navigate, from]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-gray-900 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <Bot className="h-12 w-12 text-blue-400 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
            Leading Edge AI
          </h1>
          <p className="text-slate-400 mt-2">Project Management System</p>
        </div>

        <Card className="bg-slate-800/70 border-slate-700">
          <CardHeader>
            <CardTitle className="text-2xl text-slate-200">Authentication Required</CardTitle>
            <CardDescription className="text-slate-400">
              Access this system using your authentication link
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4 text-slate-300">
              <p className="text-sm">To access the system:</p>
              <ol className="list-decimal list-inside space-y-2 text-sm">
                <li>Use the authentication link provided to you</li>
                <li>The link contains your secure access credentials</li>
                <li>You will be automatically redirected after verification</li>
              </ol>
              <p className="text-xs text-slate-400 mt-4">
                If you don't have an authentication link, please contact your system administrator.
              </p>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default LoginPage;